import { gql } from "@apollo/client";

export const GET_ALL_CONTACTS = gql`
	query getContacts(
		$limit: Int
		$offset: Int
		$order_by: msgbox_Contact_order_by!
		$condition: msgbox_Contact_bool_exp
	) {
		msgbox_Contact(
			limit: $limit
			offset: $offset
			order_by: [$order_by]
			where: $condition
		) {
			Name
			MobileNumber
			CreatedOn
			ContactId
			APIAccountId
			Status
			TagContacts {
				TagId
				Tag {
					Name
					TagId
				}
			}
		}
		msgbox_Contact_aggregate(where: $condition) {
			aggregate {
				count
			}
		}
	}
`;
